import React, { useEffect } from "react";
import OpenLibraryMcq from "./OpenLibraryMcq";
import OpenLibraryImg from "./OpenLibraryImg";
import ComponentType from "../../Enum/ComponentTypeEnum";
import SourceLibrary from "../../Enum/SourceLibraryEnum";
// css comes in libraryBox.css in hw

const OpenLibraryQuestion = ({
  filter,
  chaptersDataToPass,
  setClick,
  setClick1,
  setQuestions,
  selectedQuestion,
  selQueID,
  libraryQuestions,
  questions,
  sourceLibrary,
  componentType,
  setOpenQuestionBox,
  hideSelectBox,
}) => {
  console.log("Selected Questions in OpenLibraryQuestion:", selectedQuestion);
  console.log("chaptersDataToPass Data:", chaptersDataToPass);
  const handleAddingQuestions = () => {
    console.log("===== BUTTON CLICKED =====");
    console.log("Original Selected Questions:", selectedQuestion);

    let othersChapter = null;

    console.log("chaptersDataToPass:", chaptersDataToPass);

    if (Array.isArray(chaptersDataToPass)) {
      othersChapter = chaptersDataToPass
        ?.flatMap((section) => section.bookInfo || [])
        ?.flatMap((book) => book.chapterData || [])
        ?.find(
          (chapter) => chapter?.chapterName?.toLowerCase().trim() === "others",
        );
    }

    if (
      sourceLibrary === SourceLibrary.FROM_AI_LIBRARY &&
      filter.bookChapter?.chapterId
    ) {
      othersChapter = {
        id: filter.bookChapter.chapterId,
        chapterName: filter.bookChapter.chapterName,
      };
    }

    console.log("Others Chapter Found:", othersChapter);

    const selectedQustionData = selectedQuestion.map((val, index) => {
      console.log(`\n---- Processing Question ${index + 1} ----`);
      console.log("Before:", val.chapter_id);

      const updatedQuestion = { ...val };
      delete updatedQuestion.question;

      if (updatedQuestion.chapter_id == null) {
        console.log("Chapter ID is NULL/UNDEFINED → Setting Others");

        if (othersChapter?.id) {
          updatedQuestion.chapter_id = othersChapter.id;
        } else {
          console.log("⚠ Others chapter not found!");
        }
      } else {
        console.log("Chapter ID already present → Keeping same");
      }

      console.log("After:", updatedQuestion.chapter_id);

      return updatedQuestion;
    });

    console.log("Final Data To Add:", selectedQustionData);

    setQuestions((prev) => [...prev, ...selectedQustionData]);

    setClick((prev) => !prev);
    setClick1(false);

    if (typeof setOpenQuestionBox === "function") {
      setOpenQuestionBox(false);
    }

    for (const que of selQueID) {
      localStorage.removeItem(`isChecked_${que}`);
    }
  };

  useEffect(() => {
    return () => {
      localStorage.removeItem(`isCheckedQsBank`, "hideSelectBox");
    };
  }, []);
  return (
    <>
      <div className="library_transprant_body">
        <img
          src="/images/cross-circle3.svg"
          className="library_close_btn"
          alt=""
          onClick={(e) => setClick(false)}
        />
        <div className="p-4 library_container">
          <div className="d-flex align-items-center gap-3">
            <img
              src="/images/back_arrow.svg"
              alt=""
              onClick={(e) => setClick(false)}
            />

            <span className="select_library_header">
              Select From
              {/* {sourceLibrary === SourceLibrary.FROM_SCHOOL_LIBRARY ? " School Library" : " B4S Library"} */}
              {sourceLibrary === SourceLibrary.FROM_SCHOOL_LIBRARY &&
                " School Library"}
              {sourceLibrary === SourceLibrary.FROM_B4S_LIBRARY &&
                " B4S Library"}
              {sourceLibrary === SourceLibrary.FROM_AI_LIBRARY &&
                " AI Generator"}
            </span>
          </div>
          <div className="mt-3 d-flex" style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <div
                className="d-flex"
                style={{
                  flex: "4",
                  justifyContent: "space-evenly",
                  marginBottom: "10px",
                }}
              >
                <div className=" hw_open_liberary_box">
                  <span className="hw_libriry_heading">Class</span>
                  <span className="hw_libriry_subheading">
                    {filter?.standard?.name}
                  </span>
                </div>
                <div className=" hw_open_liberary_box">
                  <span className="hw_libriry_heading">Section</span>
                  <span className="hw_libriry_subheading">
                    {filter?.section?.name}
                  </span>
                </div>
                <div className=" hw_open_liberary_box">
                  <span className="hw_libriry_heading">Subject</span>
                  <span className="hw_libriry_subheading">
                    {filter?.subject?.name}
                  </span>
                </div>
                <div className="mt-2 d-flex justify-content-between">
                  <span className="open_libriry_topic_name">{filter.name}</span>
                  <button
                    onClick={handleAddingQuestions}
                    className="btn library_next_btn"
                  >
                    {componentType === ComponentType.ASSESSMENT &&
                      "Add to Assessment"}
                    {componentType === ComponentType.HOMEWORK &&
                      "Add to Homework"}
                    {componentType === ComponentType.QUESTION_BANK &&
                      "Add to Question Bank"}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className=" mt-3 open_library_container">
            {selectedQuestion &&
              selectedQuestion.length > 0 &&
              selectedQuestion.map((sQuestion, index) =>
                sQuestion?.question_type === "false" ? (
                  <OpenLibraryMcq
                    key={index}
                    filter={filter}
                    questionNumber={index}
                    sQuestion={sQuestion}
                    libraryQuestions={libraryQuestions}
                  />
                ) : (
                  <OpenLibraryImg
                    key={index}
                    filter={filter}
                    questionNumber={index}
                    sQuestion={sQuestion}
                  />
                ),
              )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OpenLibraryQuestion;
